// Parametric child avatars — friendly faces in the Bloom illustration style.

const VARIANTS = [
  { bg: "#FFE7D6", skin: "#E5A87C", hair: "#2E2420", style: "short" }, // Aarav
  { bg: "#FFF1CC", skin: "#F6C9A0", hair: "#7A4A2B", style: "bob" }, // Sophia
  { bg: "#DFF6EC", skin: "#F1BE93", hair: "#C97B3D", style: "spiky" }, // Ethan
  { bg: "#E3F2FD", skin: "#D99B6C", hair: "#3B2A20", style: "ponytails" }, // Amelia
  { bg: "#F3E8FF", skin: "#9C6B43", hair: "#1F1B18", style: "curly" }, // Noah
  { bg: "#FFE4EC", skin: "#F6C9A0", hair: "#E07A3F", style: "buns" }, // Olivia
];

function Hair({ style, color }) {
  switch (style) {
    case "short":
      return <path d="M19 46 Q18 22 40 21 Q62 22 61 46 Q60 33 40 32 Q20 33 19 46 Z" fill={color} />;
    case "bob":
      return (
        <g fill={color}>
          <path d="M18 46 Q17 20 40 20 Q63 20 62 46 Q60 31 40 30 Q20 31 18 46 Z" />
          <path d="M18 44 Q14 58 20 64 Q26 62 26 54 Q22 50 22 44 Z" />
          <path d="M62 44 Q66 58 60 64 Q54 62 54 54 Q58 50 58 44 Z" />
        </g>
      );
    case "spiky":
      return (
        <g fill={color}>
          <path d="M19 46 Q18 24 40 23 Q62 24 61 46 Q60 34 40 33 Q20 34 19 46 Z" />
          <path d="M27 28 L30 15 L34 26 Z M37 25 L40 12 L43 25 Z M46 26 L50 15 L53 28 Z" />
        </g>
      );
    case "ponytails":
      return (
        <g fill={color}>
          <path d="M19 46 Q18 21 40 20 Q62 21 61 46 Q60 32 40 31 Q20 32 19 46 Z" />
          <ellipse cx="13" cy="44" rx="7" ry="10" />
          <ellipse cx="67" cy="44" rx="7" ry="10" />
          <circle cx="17" cy="36" r="3" fill="#EF476F" />
          <circle cx="63" cy="36" r="3" fill="#EF476F" />
        </g>
      );
    case "curly":
      return (
        <g fill={color}>
          <circle cx="26" cy="32" r="8" />
          <circle cx="34" cy="26" r="8" />
          <circle cx="43" cy="25" r="8" />
          <circle cx="52" cy="28" r="8" />
          <circle cx="58" cy="35" r="7" />
          <path d="M19 46 Q18 30 40 29 Q62 30 61 46 Q60 36 40 35 Q20 36 19 46 Z" />
        </g>
      );
    case "buns":
      return (
        <g fill={color}>
          <path d="M19 46 Q18 22 40 21 Q62 22 61 46 Q60 33 40 32 Q20 33 19 46 Z" />
          <circle cx="21" cy="22" r="8" />
          <circle cx="59" cy="22" r="8" />
          <circle cx="21" cy="17" r="2.5" fill="#FFD166" />
          <circle cx="59" cy="17" r="2.5" fill="#FFD166" />
        </g>
      );
    default:
      return null;
  }
}

export function ChildAvatar({ variant = 0, className, "data-testid": testId }) {
  const v = VARIANTS[variant % VARIANTS.length];
  return (
    <svg viewBox="0 0 80 80" className={className} role="img" aria-label="Child avatar" data-testid={testId}>
      <circle cx="40" cy="40" r="40" fill={v.bg} />
      <circle cx="40" cy="46" r="22" fill={v.skin} />
      <Hair style={v.style} color={v.hair} />
      <circle cx="33" cy="46" r="2.7" fill="#2B2D42" />
      <circle cx="47" cy="46" r="2.7" fill="#2B2D42" />
      <circle cx="34" cy="45" r="0.9" fill="#FFFFFF" />
      <circle cx="48" cy="45" r="0.9" fill="#FFFFFF" />
      <path d="M34 54 Q40 59 46 54" stroke="#2B2D42" strokeWidth="2.6" strokeLinecap="round" fill="none" />
      <circle cx="27" cy="52" r="3.4" fill="#EF476F" opacity="0.25" />
      <circle cx="53" cy="52" r="3.4" fill="#EF476F" opacity="0.25" />
    </svg>
  );
}
